import { Moon, Sun1 } from 'iconsax-react'
import * as React from 'react'

import { useSidebar } from '@/components/ui/sidebar'
import useTheme from '@/hooks/useSwitchTheme'
import { cn } from '@/lib/utils'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

export const DarkModeSwitch = () => {
  const { isDarkMode, toggleTheme } = useTheme()
  const [isChecked, setIsChecked] = React.useState(isDarkMode)
  const { state } = useSidebar()

  const isCollapsed = state === 'collapsed'

  const handleCheckedChange = () => {
    setIsChecked((prev: any) => !prev)
    toggleTheme()
  }

  //VERTICAL
  if (isCollapsed) {
    return (
      <div
        className="relative inline-flex p-3 items-center h-[56px] w-[32px] cursor-pointer rounded-full border border-neutralColor30 shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-transparent"
        onClick={handleCheckedChange}
      >
        <div className="absolute top-[6px] left-1/2 -translate-x-1/2 flex transition-colors duration-300 z-20">
          <Sun1
            size={14}
            color={
              isDarkMode
                ? SocialMirrorPalette.neutralColor
                : SocialMirrorPalette.staticWhite
            }
          />
        </div>

        <div className="absolute bottom-[6px] left-1/2 -translate-x-1/2 flex items-center justify-center transition-colors duration-300 z-20">
          <Moon
            size={14}
            color={
              isDarkMode
                ? SocialMirrorPalette.staticWhite
                : SocialMirrorPalette.neutralColor
            }
          />
        </div>

        <div
          className={cn(
            'absolute left-1/2 -translate-x-1/2 h-[24px] w-[24px] rounded-full bg-primaryColor shadow-lg transition-transform z-10',
            isChecked ? 'translate-y-[13px]' : '-translate-y-[13px]',
          )}
        />
      </div>
    )
  }

  // HORIZONTAL
  return (
    <div
      className="relative inline-flex p-3 items-center h-[32px] w-[56px] cursor-pointer rounded-full border border-neutralColor30 shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-transparent"
      onClick={handleCheckedChange}
    >
      <div className="absolute left-[6px] top-1/2 -translate-y-1/2 flex transition-colors duration-300 z-20">
        <Sun1
          size={14}
          color={
            isDarkMode
              ? SocialMirrorPalette.neutralColor
              : SocialMirrorPalette.staticWhite
          }
        />
      </div>

      <div className="absolute right-[6px] top-1/2 -translate-y-1/2 flex items-center justify-center transition-colors duration-300 z-20">
        <Moon
          size={14}
          color={
            isDarkMode
              ? SocialMirrorPalette.staticWhite
              : SocialMirrorPalette.neutralColor
          }
        />
      </div>

      <div
        className={cn(
          'absolute top-1/2 -translate-y-1/2 h-[24px] w-[24px] rounded-full bg-primaryColor shadow-lg transition-transform z-10',
          isChecked ? 'translate-x-[15px]' : 'translate-x-[-11px]',
        )}
      />
    </div>
  )
}
